<template>
  <div>
    <DataLoader :is_on="creating_report" />
    <div id="table" class="report-table predmeti-report">
      <div class="rocisnik-top">
        <div class="rokovnik-title">
          {{ $store.state.predmeti_report_data.naslov }}
        </div>
        <div class="print-wrapper" @click="print()">
          <span>{{ $t("reports.predmeti.save_report") }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="36"
            viewBox="0 0 30 36"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5574 0C11.0601 0 9.81104 1.21625 9.68029 2.8016C9.40692 6.11624 9.33774 9.44566 9.47296 12.7686C9.30973 12.7802 9.14654 12.7923 8.98336 12.8049L6.10045 13.0283C4.25777 13.1711 3.2277 15.3548 4.22251 17.0096C6.34414 20.5386 9.07791 23.6066 12.2781 26.05L13.4331 26.9318C14.3695 27.6468 15.6308 27.6468 16.5672 26.9318L17.7222 26.05C20.9224 23.6066 23.6562 20.5386 25.7778 17.0096C26.7726 15.3548 25.7425 13.1711 23.8999 13.0283L21.017 12.8049C20.8538 12.7923 20.6906 12.7802 20.5273 12.7686C20.6626 9.44565 20.5934 6.11623 20.32 2.80158C20.1893 1.21624 18.9402 0 17.4429 0H12.5574ZM12.4482 14.1217C12.2281 10.4452 12.2692 6.75601 12.5712 3.08571H17.4291C17.7311 6.75601 17.7722 10.4452 17.5521 14.1217C17.5274 14.5339 17.6593 14.9394 17.9181 15.2474C18.177 15.5555 18.5412 15.7404 18.9294 15.7607C19.5552 15.7934 20.1807 15.834 20.8059 15.8825L22.8996 16.0447C21.0424 18.9521 18.717 21.4911 16.0284 23.5438L15.0002 24.3289L13.9719 23.5438C11.2833 21.4911 8.95788 18.9521 7.10071 16.0447L9.19443 15.8825C9.81957 15.834 10.4451 15.7934 11.0709 15.7607C11.4591 15.7404 11.8233 15.5555 12.0822 15.2474C12.341 14.9394 12.4729 14.5339 12.4482 14.1217Z"
              fill="#606076"
            />
            <path
              d="M2.90323 28.2857C2.90323 27.4336 2.25332 26.7429 1.45161 26.7429C0.649909 26.7429 0 27.4336 0 28.2857V32.4C0 34.3882 1.51646 36 3.3871 36H26.6129C28.4835 36 30 34.3882 30 32.4V28.2857C30 27.4336 29.3501 26.7429 28.5484 26.7429C27.7467 26.7429 27.0968 27.4336 27.0968 28.2857V32.4C27.0968 32.684 26.8801 32.9143 26.6129 32.9143H3.3871C3.11986 32.9143 2.90323 32.684 2.90323 32.4V28.2857Z"
              fill="#606076"
            />
          </svg>
        </div>
        <div
          v-if="!$store.state.predmeti_report_data.is_general_view"
          class="filters-wrapper"
        >
          <div class="status-filter-wrapper">
            <label>{{ $t("reports.predmeti.status") }}</label>
            <CustomDropdown
              :id="'drop_statusi'"
              :drop_items="statusi"
              v-model="active_status"
              init_text="Status"
            />
          </div>
          <div class="remove-this nositelj-checkbox" v-if="nositelj != null">
            <input
              id="nositelj-filter"
              type="checkbox"
              @input="
                filter_active = !filter_active;
                filterIt();
              "
            />
            <label for="nositelj-filter">{{
              $t("reports.predmeti.filter_by")
            }}</label>
          </div>
        </div>
      </div>
      <a @click="goBack()" class="entry-exit"
        ><img src="@/assets/img/entry_form_close.svg"
      /></a>
      <div class="total-num">
        {{ $t("reports.predmeti.total-num") }}:
        <span>{{ this.predmeti.length }}</span>
      </div>
      <div id="wrapp-roc-pdf">
        <div class="report-row report-main-header">
          <div class="column column1">
            {{ $t("reports.predmeti.h1") }}
          </div>
          <div class="column column2">
            {{ $t("reports.predmeti.h2") }}
          </div>
          <div class="column column3">
            {{ $t("reports.predmeti.h3") }}
          </div>
          <div class="column column4">
            {{ $t("reports.predmeti.h4") }}
          </div>
          <div class="column column5">
            {{ $t("reports.predmeti.h5") }}
          </div>
          <div class="column column6">
            {{ $t("reports.predmeti.h6") }}
          </div>
          <div class="column column7">
            {{ $t("reports.predmeti.h7") }}
          </div>

          <div class="column column7">
            {{ $t("reports.predmeti.h9") }}
          </div>

          <div v-if="is_archived" class="column column9">
            <span>{{ $t("reports.predmeti.h8") }}</span>
            <div
              class="svg-sort"
              @click="
                active_sort == 'desc' ? sortAscending() : sortDescending()
              "
            >
              <svg
                :style="
                  active_sort == 'asc' ? 'transform: rotateX(180deg);' : ''
                "
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M11.1924 13.593H12.8894V0.41503C12.8908 0.30399 12.936 0.197983 13.0153 0.120213C13.0945 0.0424417 13.2014 -0.00077098 13.3124 3.00579e-05H16.7264C16.7815 -0.000630061 16.8362 0.0095887 16.8874 0.0300994C16.9385 0.0506103 16.9852 0.0810124 17.0245 0.119561C17.0639 0.158111 17.0952 0.204055 17.1168 0.254755C17.1384 0.305454 17.1499 0.359923 17.1504 0.41503V13.593H18.8453C18.9247 13.5926 19.0026 13.6145 19.0701 13.6563C19.1377 13.698 19.1921 13.7578 19.2273 13.829C19.2619 13.8994 19.2754 13.9783 19.2661 14.0562C19.2569 14.134 19.2254 14.2076 19.1753 14.268L15.3494 19.854C15.3091 19.9023 15.2586 19.941 15.2016 19.9675C15.1445 19.9939 15.0822 20.0074 15.0193 20.007C14.8913 20.007 14.7694 19.951 14.6894 19.853L10.8634 14.267C10.8134 14.2066 10.7819 14.133 10.7726 14.0552C10.7634 13.9773 10.7769 13.8984 10.8114 13.828C10.8466 13.7568 10.9011 13.697 10.9686 13.6553C11.0362 13.6135 11.1141 13.5916 11.1934 13.592L11.1924 13.593Z"
                  fill="#3326AE"
                />
                <path
                  d="M11.2316 0.0191466H1.2417C1.20918 0.0187466 1.1759 0.0247471 1.14572 0.0368468C1.11554 0.0489464 1.08804 0.0669455 1.06481 0.0897452C1.04158 0.112445 1.02308 0.139647 1.01036 0.169547C0.997643 0.199446 0.990963 0.231646 0.990702 0.264145V3.17815C0.990702 3.31314 1.1027 3.42315 1.2407 3.42315H11.2316C11.3696 3.42315 11.4816 3.31314 11.4816 3.17815V0.264145C11.4814 0.231646 11.4747 0.199446 11.462 0.169547C11.4493 0.139647 11.4308 0.112445 11.4075 0.0897452C11.3843 0.0669455 11.3568 0.0489464 11.3266 0.0368468C11.2964 0.0247471 11.2642 0.0187466 11.2316 0.0191466Z"
                  fill="#3326AE"
                />
                <path
                  d="M1.23828 19.722H4.43925C4.57825 19.722 4.68826 19.612 4.68826 19.477V16.562C4.68806 16.5295 4.68136 16.4973 4.66866 16.4674C4.65596 16.4375 4.63745 16.4104 4.61415 16.3876C4.59095 16.3648 4.56345 16.3469 4.53325 16.3348C4.50305 16.3227 4.47085 16.3166 4.43826 16.317H1.23828C1.20576 16.3166 1.17349 16.3227 1.1433 16.3348C1.11312 16.3469 1.08562 16.3648 1.06239 16.3876C1.03917 16.4104 1.02066 16.4375 1.00794 16.4674C0.995232 16.4973 0.988551 16.5295 0.988281 16.562V19.477C0.988281 19.612 1.10028 19.722 1.23828 19.722Z"
                  fill="#3326AE"
                />
                <path
                  d="M1.25644 14.4055H6.9214C7.0594 14.4055 7.1714 14.2965 7.1714 14.1615V11.2464C7.1712 11.2139 7.1645 11.1818 7.1518 11.1518C7.1391 11.1219 7.1206 11.0948 7.0973 11.072C7.0741 11.0493 7.0466 11.0313 7.0164 11.0192C6.9862 11.0071 6.954 11.001 6.9214 11.0014H1.25644C1.22391 11.001 1.19164 11.0071 1.16145 11.0192C1.13127 11.0313 1.10377 11.0493 1.08055 11.072C1.05732 11.0948 1.03881 11.1219 1.0261 11.1518C1.01338 11.1818 1.0067 11.2139 1.00644 11.2464V14.1615C1.00644 14.2965 1.11844 14.4055 1.25644 14.4055Z"
                  fill="#3326AE"
                />
                <path
                  d="M1.25251 8.85859H9.08043C9.21843 8.85859 9.33043 8.74859 9.33043 8.61359V5.69959C9.32963 5.63399 9.30293 5.57139 9.25603 5.52549C9.20923 5.47949 9.14603 5.45409 9.08043 5.45459H1.25251C1.18691 5.45409 1.12377 5.47949 1.07691 5.52549C1.03006 5.57139 1.00331 5.63399 1.00251 5.69959V8.61359C1.00251 8.74859 1.11452 8.85859 1.25251 8.85859Z"
                  fill="#3326AE"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="report-section">
          <!-- <div class="report-row report-date-row"></div> -->
          <div
            v-for="(predmet, key) in predmeti"
            :key="key"
            class="report-row report-rociste"
          >
            <div class="column column1">
              {{ predmet.broj_predmeta }}
            </div>
            <div class="column column2 multiple-values">
              <div
                v-for="(fiz_s, key) in predmet.connect_fiz_stranka"
                :key="key"
              >
                {{ fiz_s.fizicka_osoba.ime }} {{ fiz_s.fizicka_osoba.prezime }}
              </div>
              <div
                v-for="(prav_s, key) in predmet.prav_connect_stranka"
                :key="'100' + key"
              >
                {{ prav_s.pravna_osoba.ime }}
              </div>
            </div>
            <div class="column column3 multiple-values">
              <div
                v-for="(fiz_pr, key) in predmet.connect_fiz_protustranka"
                :key="'200' + key"
              >
                {{ fiz_pr.fizicka_osoba.ime }}
                {{ fiz_pr.fizicka_osoba.prezime }}
              </div>
              <div
                v-for="(prav_pr, key) in predmet.prav_connect_protustranka"
                :key="'300' + key"
              >
                {{ prav_pr.pravna_osoba.ime }}
              </div>
            </div>
            <div class="column column4 multiple-values">
              <div v-for="(sp, key) in predmet.spis" :key="'500' + key">
                {{
                  sp.posl_br != undefined && sp.posl_br != null
                    ? sp.posl_br
                    : ""
                }}
              </div>
            </div>
            <div class="column column5 multiple-values">
              <div v-for="(inst, key) in predmet.spis" :key="'400' + key">
                {{
                  inst.institucija != undefined && inst.institucija != null
                    ? inst.institucija.naziv
                    : ""
                }}
              </div>
            </div>
            <div class="column column6 multiple-values">
              <div
                v-for="(odv, key) in predmet.predmet_odvjetnik_connector"
                :key="key"
              >
                <span
                  :style="
                    odv.status_odvjetnik_predmet.id_status == 2
                      ? 'font-weight:600'
                      : ''
                  "
                  >{{ odv.odvjetnik.ime }} {{ odv.odvjetnik.prezime }}</span
                >
              </div>
            </div>
            <div class="column column7 multiple-values">
              <div>{{ getStatus(predmet) }}</div>
            </div>
            <div class="column column8">
              <div>{{ getSpisCaseType(predmet) }}</div>
            </div>
            <div class="column column9" v-if="is_archived">
              <div>{{ getDate(predmet.datum_arhiviranja) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import $ from "jquery";
import gsap from "gsap";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import DataLoader from "@/components/generalComponents/DataLoader";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";

export default {
  components: {
    DataLoader,
    CustomDropdown,
  },
  data() {
    return {
      predmeti: [],
      razdoblje: "",
      creating_report: false,
      nositelj: null,
      predmeti_backup: [],
      filter_active: false,
      statusi: this.$t("reports.predmeti.statuses"),
      active_status: 0,
      is_archived: false,
      active_sort: "desc",
    };
  },
  watch: {
    active_status: function () {
      this.filterIt();
    },
  },
  methods: {
    getSpisCaseType(predmet) {
      const rootSpisi = predmet.spis;
 
      if (rootSpisi.length > 0) {
        if (rootSpisi[0].postupak != null) {
          return rootSpisi[0].postupak.naziv;
        }
        return "N/A";
      } else return "N/A";
    },
    sortDescending() {
      this.predmeti.sort(
        (a, b) => new Date(b.datum_arhiviranja) - new Date(a.datum_arhiviranja)
      );
      this.active_sort = "desc";
    },
    sortAscending() {
      this.predmeti.sort(
        (a, b) => new Date(a.datum_arhiviranja) - new Date(b.datum_arhiviranja)
      );
      this.active_sort = "asc";
    },
    getStatus(pr) {
      return pr.is_destroyed
        ? this.$t("reports.predmeti.s1")
        : pr.is_archived
        ? this.$t("reports.predmeti.s2")
        : this.$t("reports.predmeti.s3");
    },
    async print() {
      this.creating_report = true;
      let temp_str = $("html").clone();
      $(temp_str).find(".print-wrapper,.entry-exit,.filters-wrapper").remove();
      let html_to_print = $(temp_str)[0].outerHTML;
      await ms_calendar
        .printCalendar(html_to_print)
        .then(async (resp) => {
          var newBlob = new Blob([resp.data], {
            type: "application/pdf",
          });
          var data = window.URL.createObjectURL(newBlob);

          var link = document.createElement("a");
          link.href = data;
          link.download =
            this.nositelj != null
              ? `${this.$t("reports.predmeti.file_name")}${
                  this.$store.state.predmeti_report_data.odvjetnik_name
                }-${moment().format("l")}.pdf`
              : `${this.$t("reports.predmeti.file_name")}${moment().format(
                  "l"
                )}.pdf`;
          link.click();
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
          }, 100);
          this.creating_report = false;
        })
        .catch((_err) => {
          this.creating_report = false;
        });
      //html_to_print sadrzi html izvjestaj spreman za print
      //poslati html_to_print na back endpoint
    },
    getDate(date) {
      return moment(date).format("DD.MM.yyyy.");
    },
    getToday() {
      return moment().format("DD.MM.yyyy.");
    },
    getDayName(date) {
      return moment(date).format("dddd");
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    goBack() {
      this.$router.go(-1);
    },
    filterIt() {
      switch (this.active_status) {
        case 0:
          this.predmeti = [...this.predmeti_backup];
          break;
        case 1:
          this.predmeti = this.predmeti_backup.filter(
            (pr) => !pr.is_archived && !pr.is_destroyed
          );
          break;
        case 2:
          this.predmeti = this.predmeti_backup.filter(
            (pr) => pr.is_archived && !pr.is_destroyed
          );
          break;
        case 3:
          this.predmeti = this.predmeti_backup.filter((pr) => pr.is_destroyed);
          break;
        default:
          break;
      }
      if (this.filter_active) {
        this.predmeti = this.predmeti.filter((pr) =>
          pr.predmet_odvjetnik_connector.find(
            (od) =>
              od.odvjetnik.uid == parseInt(this.nositelj) &&
              od.status_odvjetnik_predmet.id_status == 2
          )
        );
      }
    },
  },
  created() {
    this.nositelj = this.$store.state.predmeti_report_data.odvjetnik_nositelj;
  },
  mounted() {
    document.body.classList.add("new-entry");

    this.is_archived = this.$route.query.archived ? true : false;

    if (this.$store.state.predmeti_report_data.naslov == "") {
      this.$router.go(-1);
    }
    this.predmeti = this.$store.state.predmeti_report_data.all_predmeti;
    if (this.is_archived) {
      this.sortDescending();
    }
    this.predmeti_backup = [...this.predmeti];
    console.log(this.predmeti);
    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  destroyed() {
    this.$store.state.predmeti_report_data = {
      all_predmeti: [],
      naslov: "",
      odvjetnik_nositelj: null,
      odvjetnik_name: "",
      is_general_view: false,
    };
    document.body.classList.remove("new-entry");
    $(".entry-exit").off();
  },
};
</script>
